
import store from '@/store';
import { Options, Vue } from 'vue-class-component';
import RestorantCard from './Common/RestorantCard.vue'
@Options({
  components:{
    RestorantCard
  },
  props: {
   
  }
})
export default class Restorants extends Vue {
  get restorants(){
    return store.getters.availableRestorants;
  }


  
}
